import React, { useEffect, Profiler, useState } from 'react'
// import ReactPWAInstallProvider, { useReactPWAInstall } from "react-pwa-install";
import './Component-css/Downloadbutton.css?v=0.1'
// let deferredPrompt;
const Downloadbutton = () => {
  const [supportsPWA, setSupportsPWA] = useState(false)
  const [promptInstall, setPromptInstall] = useState(null)
  const [showDownloadPopup, setShowDownloadPopup] = useState(true);
  useEffect(() => {
    const handler = e => {
      e.preventDefault()
      console.log('we are being triggered :D')
      setSupportsPWA(true)
      setPromptInstall(e)
    }
    window.addEventListener('beforeinstallprompt', handler)

    return () => window.removeEventListener('transitionend', handler)
  }, [])

  const onClick = evt => {
    evt.preventDefault()
    if (!promptInstall) {

      return
    }
    promptInstall.prompt()
  }
  if (!supportsPWA) {
    return null
  }


  return (
    <>
      {/* // <div
    //   className='my-stickey-footer'
    //   style={{
    //     position: 'fixed',
    //     bottom: '57px',
    //     width: '100%',
    //     maxWidth: 480,
    //     backgroundColor: 'transparent',
    //     left: '0px'
    //   }}
    // >
    //   <div className='text-center' style={{ zoom: '1.2', padding: '10px 0px' }}>
    //     <button
    //       onClick={onClick}
    //       className='btn btn-sm text-white download_btn_bottom bounce-div'
    //       style={{ fontWeight: 500 }}
    //     >
          
    //       DOWNLOAD OUR APP
          
    //     </button>
    //   </div>
    // </div> */}

      {showDownloadPopup && (
        <div
          className="tejal_download_overlay"
          onClick={() => setShowDownloadPopup(false)}
        >
          <div
            className="tejal_download_popup"
            onClick={(e) => e.stopPropagation()}
          >

            {/* Glow */}
            <div className="tejal_download_glow"></div>

            {/* Close */}
            <button
              className="tejal_download_close"
              onClick={() => setShowDownloadPopup(false)}
            >
              ×
            </button>

            {/* App Icon */}
            <div className="tejal_download_icon_box">
              <img
                src="./install.png"
                alt="Install App"
              />
            </div>

            <h3>
              Install <span>Sultan Ludo</span>
            </h3>

            <p>
              Get the ultimate gaming experience
            </p>

            {/* Features */}
            <div className="tejal_download_features">

              <div>
                <span>⚡</span>
                <small>Fast</small>
              </div>

              <div>
                <span>🎮</span>
                <small>Smooth</small>
              </div>

              <div>
                <span>🔒</span>
                <small>Secure</small>
              </div>

            </div>

            {/* Buttons */}
            <div className="tejal_download_buttons">

              <button
                className="tejal_later_btn"
                onClick={() => {
                  localStorage.setItem(
                    "downloadPopupClosed",
                    "true"
                  );

                  setShowDownloadPopup(false);
                }}
              >
                Later
              </button>

              <button
                className="tejal_download_now_btn"
                onClick={onClick}
              >
                <span>↓</span>
                Download App
              </button>

            </div>

            <div className="tejal_download_bottom">
              ✦ Fast Access • Better Experience ✦
            </div>

          </div>
        </div>
      )}
    </>
  )
}

export default Downloadbutton
